import {Component} from "react";
import "../styles/DisplayScreensStyles.css"
import Fade from "react-reveal/Fade";

class DisplayScreens extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if(this.props.message !== undefined) {
            return(
                <div className={"display-screen"}>
                    <img className={"display-screen_image"} src={process.env.PUBLIC_URL + `${this.props.screen}`} alt="screen" />
                    <Fade delay={2000}>
                        <div className={"push_screen"}>
                            <img src={process.env.PUBLIC_URL + `${this.props.message}`} alt="screen"/>
                        </div>
                    </Fade>
                </div>
            );
        } else {
            return(
                <div className={"display-screen"}>
                    <img className={"display-screen_image"} src={process.env.PUBLIC_URL + `${this.props.screen}`} alt="screen" />
                </div>
            );
        }
    }
}
export default DisplayScreens;